import { render, staticRenderFns } from "./FieldText.vue?vue&type=template&id=680159be&scoped=true"
import script from "./FieldText.vue?vue&type=script&lang=js"
export * from "./FieldText.vue?vue&type=script&lang=js"
import style0 from "./FieldText.vue?vue&type=style&index=0&id=680159be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680159be",
  null
  
)

export default component.exports